import { toQueryString } from '@fiverr-private/futile/lib/url/toQueryString';
import { logger } from '@fiverr-private/obs';
import {
    PATHFINDER_ERROR,
    FIVERR_FQDN,
    ROOT,
    DEV_PREFIX,
    ROUTE_PARAM_REGEX
} from './constants';

/**
 * Logs an error to the console or passes it to a optional callback and returns the ROOT path
 * @param {String} errorMsg error message
 * @param {Function | undefined} [errorCallback] optional error callback function
 */
const onError = (errorMsg, errorCallback) => {
    const message = [PATHFINDER_ERROR, errorMsg].join(' ');

    logger.error(new Error(message));

    if (typeof errorCallback === 'function') {
        errorCallback(message);
    }
};

/**
 * Fills in params in routes from route.rb
 * @param {String} namedRoute route for resolution
 * @param {Object | null} [userParams] Contains the user params to inject in the route
 * @param {Function} [options.errorCallback] Callback function to execute if an error occurs.
 * @param {Object} [options.query] A mapping of query params.
 * @param {Boolean} [options.absolute] Whether the route should be absolute or relative.
 */
export const pathfinder = (
    namedRoute,
    userParams = null,
    { errorCallback, query, absolute } = {}
) => {
    if (!namedRoute || typeof namedRoute !== 'string') {
        onError(`Route missing for ${namedRoute}`, errorCallback);

        return ROOT;
    }

    if (namedRoute.indexOf(DEV_PREFIX) === 0) {
        onError('Using dev only route. Make sure to replace it before going live.');

        return ROOT;
    }

    let output;

    try {
        output = fiverrRoutes[namedRoute];
    } catch (error) {
        onError('Missing global routes object', errorCallback);

        return ROOT;
    }

    if (!output) {
        onError(`Can't find the requested route (${namedRoute}). It may be misspelled or got removed`, errorCallback);

        return ROOT;
    }

    const missingRequired = [];

    output = output.replace(ROUTE_PARAM_REGEX, (match, prefix, name) => {

        if (userParams) {
            const param = userParams[name];

            if (param) {
                return `${prefix}${param}`;
            }
        }

        if (match[0] !== '(') {
            missingRequired.push(name);
        }

        return '';
    });

    if (missingRequired.length) {
        onError(`Required params missing for ${namedRoute} route: ${missingRequired.join(', ')}`, errorCallback);

        return ROOT;
    }

    if (query) {
        output = [output, toQueryString(query)].join('?');
    }

    return absolute ? FIVERR_FQDN + output : output;
};

export default pathfinder;
